import cn from 'classnames'
import {FC, ReactNode} from 'react'

import {Text, TextFontWeight} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'

type FormSummaryItemWithButtonProps = {
  title: string | ReactNode
  button?: ReactNode
  fontWeight?: TextFontWeight
  textColor?: string
  isLowercase?: boolean
}

export const FormSummaryItemWithButton: FC<FormSummaryItemWithButtonProps> = ({
  title,
  button,
  fontWeight = TextFontWeight.regular,
  textColor = theme.palette.text.light,
  isLowercase = false,
}) => (
  <>
    <div className="row">
      <Text
        color={textColor}
        fontWeight={fontWeight}
        className={cn('truncated', isLowercase ? 'lowercase' : '')}
      >
        {title}
      </Text>
      {button && <div className="button">{button}</div>}
    </div>

    <style jsx>{`
      .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }
      .button {
        white-space: nowrap;
        margin-left: ${theme.spacing[3]};
      }
    `}</style>
  </>
)
